@if (showHeader) {
  <ui-message [type]="'info'">{{ 'orderProcess.payment.payInStorePayment.note' | translate }}</ui-message>
  <div class="d-flex mt-5 mb-4 flex-column align-items-start flex-lg-row align-items-lg-end mt-2">
    <h4 class="me-2 mb-0">{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>
    <div class="text-primary cursor-pointer font-md d-none d-sm-block"
         [translate]="'orderProcess.payment.whyDoAskInfo.question'"
         ngbTooltip="{{'orderProcess.payment.whyDoAskInfo.answer' | translate}}">
    </div>
  </div>
}

<payment-contact-info-b
  [userInfo]="info"
  [countryCode]="countryCode"
  [personType]="personType"
  [askForReferenceField]="personType === PAYMENT_PERSON_TYPES.COMPANY"
  (onInfoUpdated)="onInfoUpdated($event)"
  (onValidUpdated)="isValid = $event"
></payment-contact-info-b>

<ng-content select=".gift-card-and-promo-code"></ng-content>

<button class="btn btn-pink payment-confirm-btn my-4"
        [disabled]="!isValid || loading"
        (click)="submit()">
  {{ 'orderProcess.payment.confirmOrder' | translate }}
</button>

<terms-and-conditions
  (onTermsClick)="onTermsClick.emit()"
></terms-and-conditions>
